// Etiquetas amigables para los métodos de pago (clave interna → texto visible).
// `mp_card` = brick de tarjeta de Mercado Pago → se muestra como "Tarjeta".
export const PAYMENT_METHOD_LABELS: Record<string, string> = {
  mp_card: 'Tarjeta',
  mercadopago: 'Mercado Pago',
  mp_link: 'Mercado Pago (link)',
  paypal: 'PayPal',
  aplazo: 'Aplazo',
  transferencia: 'Transferencia',
  efectivo: 'Efectivo',
  tienda: 'Pago en tienda',
  oxxo: 'OXXO',
  tarjeta: 'Tarjeta',
  otro: 'Otros',
}

/** Devuelve la etiqueta amigable del método, o la clave cruda si no está mapeada. */
export function paymentMethodLabel(key?: string | null): string {
  if (!key) return '—'
  return PAYMENT_METHOD_LABELS[key.toLowerCase()] ?? key
}
